<template>
    <graphique></graphique>
</template>

<script>
import Graphique from '../components/Graphique'

export default {
    components: {
        'graphique': Graphique
    }
}
</script>

<style>

</style>
